import { isExpired, decodeToken } from "react-jwt";

export const validateToken = () => {
  return isExpired(localStorage.getItem("token"));
};
export const getTokenInfo = () => {
  return decodeToken(localStorage.getItem("token"));
};
export const setToken = (token) => {
  localStorage.setItem("token", token);
};
